import { StepProps } from 'antd';
import { SignatureRequestSteps } from '../../constants';
import { t } from '../../utils';

export const getStepsConfig = (signatureMetadata): StepProps[] => {
	const { currentStep, numberOfsteps } = signatureMetadata;
	const steps: StepProps[] = [
		{
			title: t('SendSignatureRequest.selectRecipients'),
			status:
				currentStep === SignatureRequestSteps.SelectRecipients
					? 'process'
					: currentStep === SignatureRequestSteps.PopulateFields
					? 'wait'
					: 'finish',
			icon:
				currentStep === SignatureRequestSteps.ReviewAndSend
					? 'CheckCircleFilled'
					: 'UsersOutlined',
		},
		{
			title: t('SendSignatureRequest.reviewAndSend'),
			status: currentStep === SignatureRequestSteps.ReviewAndSend ? 'process' : 'wait',
			icon: 'MailSendEnvelopeOutlined',
		},
	];

	if (numberOfsteps === 3) {
		steps.splice(0, 0, {
			title: t('SendSignatureRequest.populateFields'),
			status: currentStep === SignatureRequestSteps.PopulateFields ? 'process' : 'finish',
			icon:
				currentStep === SignatureRequestSteps.PopulateFields
					? 'PencilSquareOutlined'
					: 'CheckCircleFilled',
		});
	}

	return steps;
};
